import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import DraftTable from "./DraftTable";
import TenderTable from "./TenderTable";
import axios from "axios";
import BuyerDashboard from "./BuyerDashboard.jsx";
import TechnicalHeadDashboard from "./TechnicalHeadDashboard.jsx";
import PurchaseHeadDashboard from "./PurchaseHeadDashboard.jsx";
import FinanceHeadDashboard from "./FinanceHeadDashboard.jsx";
import CXODashboard from "./CXODashboard.jsx";
import BuyerDashboardPending from "./BuyerDashboardPending.jsx";
import TechnicalHeadPending from "./TechnicalHeadPending.jsx";
import PurchaseHeadPending from "./PurchaseHeadPending.jsx";
import FinanceHeadPending from "./FinanceHeadPending.jsx";

const DashboardPending = () => {
  const [user, setUser] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const getOrgUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setUser(res.data);
      } catch (error) {
        alert(error.response.data.Exception || "Access denied")
      }
    }
    getOrgUser();
  }, [])

  return user ? (
    user.userRoleName === "BUYER" ? (
      <BuyerDashboardPending />
    ) : user.userRoleName === "TECHNICAL_HEAD" ? (
      <TechnicalHeadPending />
    ) : user.userRoleName === "PURCHASE_HEAD" ? (
      <PurchaseHeadPending />
    ) : user.userRoleName === "FINANCE_HEAD" ?
    <FinanceHeadPending /> 
    : null
  ) : null;
};

export default DashboardPending;
